import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../landing-page/components/Footer';

const steps = [
{
  number: 1,
  img: "https://vltfzozjztfaeifjqpcg.supabase.co/storage/v1/object/public/Volaptic/Professionisti%20-%20guida/prof%201.jpeg",
  alt: 'Schermata che mostra richieste di lavoro disponibili nella zona del professionista',
  title: 'Ricevi richieste di lavoro',
  text: 'Accedi a richieste reali di clienti nella tua zona, già pronte e dettagliate.',
  quote: 'Niente caccia al cliente. Le richieste arrivano a te.'
},
{
  number: 2,
  img: "/assets/images/step2_preventivo_tablet.png",
  alt: 'Schermata per inviare un preventivo con prezzo, tempi e condizioni',
  title: 'Invia il tuo preventivo',
  text: 'Rispondi alle richieste con la tua offerta in modo semplice e veloce.',
  quote: 'Decidi tu prezzo, tempi e condizioni.'
},
{
  number: 3,
  img: "/assets/images/step3_scegli_professionista.png",
  alt: 'Schermata di confronto preventivi dove il cliente sceglie il professionista',
  title: 'Fatti scegliere',
  text: 'Il cliente confronta i preventivi e seleziona il professionista più adatto.',
  quote: 'Se lavori bene, vinci.'
},
{
  number: 4,
  img: "/assets/images/step4_pagamento_completato.png",
  alt: 'Schermata di pagamento completato dopo la fine del lavoro',
  title: 'Vieni pagato subito',
  text: 'Una volta accettato il preventivo e terminato il lavoro, organizzi il pagamento direttamente con il cliente. Stiamo lavorando a un sistema di pagamenti integrato con incassi immediati e rateizzazione.*',
  quote: 'Stiamo costruendo il futuro dei pagamenti per artigiani.'
},
{
  number: 5,
  img: "/assets/images/step5_recensioni_positive.png",
  alt: 'Schermata del profilo professionista con recensioni e valutazioni dei clienti',
  title: 'Costruisci la tua reputazione',
  text: 'Ricevi recensioni dai clienti e aumenta la tua visibilità sulla piattaforma.',
  quote: 'Più lavori bene, più lavori arrivano.'
}];


const ComeFunzionaProfessionistiPage = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="w-full bg-card border-b border-border" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px', height: '64px' }}>
        <Link to="/">
          <img
            src="/assets/images/logoenometrasp-1775046870715.png"
            alt="Volaptic"
            style={{ height: '90px', width: 'auto' }} />
          
        </Link>
        <a
          href="/"
          className="text-sm text-muted-foreground hover:text-primary transition-colors duration-250 flex items-center gap-1">
          
          ← Home
        </a>
      </header>
      {/* Hero Image */}
      <div style={{ width: '100%', height: '400px', overflow: 'hidden' }}>
        <img
          src="/assets/images/tradesman_hero.png"
          alt="A skilled tradesman working in a modern home with natural light"
          style={{ width: '100%', height: '400px', objectFit: 'cover', display: 'block' }}
        />
      </div>
      {/* Page Title */}
      <div className="max-w-4xl mx-auto px-4 md:px-6 pt-12 pb-4 text-center">
        <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-3">
          Come funziona per i Professionisti
        </h1>
        <p className="text-muted-foreground text-lg">
          Cinque semplici passi per iniziare a lavorare con Volaptic.
        </p>
      </div>
      {/* Steps */}
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-10 flex flex-col gap-16 md:gap-20">
        {steps?.map((step, index) => {
          const isEven = index % 2 === 1;
          return (
            <div
              key={step?.number}
              className={`flex flex-col ${isEven ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-8 md:gap-12`}>
              
              {/* Image */}
              <div className="flex-shrink-0 w-full md:w-auto flex justify-center">
                <img
                  src={step?.img}
                  alt={step?.alt}
                  style={{ maxWidth: '420px', width: '100%', borderRadius: '16px' }}
                  className="shadow-md" />
                
              </div>
              {/* Text */}
              <div className="flex flex-col gap-4 flex-1">
                <div className="flex items-center gap-3">
                  <span
                    className="flex-shrink-0 w-9 h-9 rounded-full bg-primary text-white flex items-center justify-center text-sm font-bold">
                    
                    {step?.number}
                  </span>
                  <h2 className="text-xl md:text-2xl font-bold text-foreground">
                    {step?.title}
                  </h2>
                </div>
                <p className="text-muted-foreground text-base leading-relaxed">
                  {step?.text}
                </p>
                <p className="text-primary italic text-base font-medium border-l-4 border-primary pl-4">
                  "{step?.quote}"
                </p>
              </div>
            </div>);

        })}
      </div>
      {/* CTA */}
      <div className="w-full bg-card border-t border-border py-12 mt-4">
        <div className="max-w-xl mx-auto px-4 text-center flex flex-col items-center gap-4">
          <h2 className="text-2xl font-bold text-foreground">Pronto a iniziare?</h2>
          <p className="text-muted-foreground">
            Unisciti ai professionisti che usano Volaptic per trovare clienti e crescere.
          </p>
          <Link to="/professional-registration-step-2">
            <button
              style={{ backgroundColor: 'var(--color-primary)' }}
              className="text-white px-8 py-3 rounded-lg text-base font-semibold hover:opacity-90 transition-opacity mt-2">
              
              Registrati come Professionista
            </button>
          </Link>
        </div>
      </div>
      {/* Disclaimer */}
      <div className="max-w-5xl mx-auto px-4 md:px-6 pb-8">
        <p className="text-gray-400 text-xs leading-relaxed">
          * La funzione "Pagamenti integrati con incassi immediati e rateizzazione" è in fase di sviluppo e sarà disponibile prossimamente. Al momento il pagamento avviene direttamente tra cliente e professionista.
        </p>
      </div>
      <Footer />
    </div>);

};

export default ComeFunzionaProfessionistiPage;